export default "__VITE_ASSET__77ffc4ed__"